import styled from 'styled-components';
import { getThemeValue, Box } from '@leagueplatform/ui-kit';

export const TabContent = styled(Box)`
  padding: ${getThemeValue('space.genesis.oneAndHalf')}px;
`;
